export default "__VITE_ASSET__zpQh2YF0__"